var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "search_svg__svg-icon",
    style: {
      width: 24,
      height: 24,
      verticalAlign: "middle"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    overflow: "hidden"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.667 170.667a320 320 0 11-320 320 320 320 0 01320-320m0-64a384 384 0 10384 384 384 384 0 00-384-384z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M896 928a32 32 0 01-22.613-9.387L739.627 784.64a32 32 0 0145.226-45.227l133.76 133.974A32 32 0 01896 928z"
  })));
}
export default SvgSearch;